import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import "$components/breakpoints.min.js"
import "$components/jquery.min.js"
// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
